module.exports = __webpack_public_path__ + "img/checked-favor_l.aa2d407f.svg";